export default __webpack_public_path__ + "static/media/userPlaceholder.8d49e377.png";